import React from 'react'
import { Link } from 'react-router-dom';
import { getBaseUrl } from './BaseUrl';

function Faied() {
    const token = localStorage.getItem("token");
   let base_url = getBaseUrl();
    
  return (
   <div
  className="container"
  style={{
    minHeight: "100dvh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <div className="row w-100" style={{ justifyContent: "center" }}>
    <div className="col-lg-6 col-md-8 col-sm-12">
      <div className="cardBox paymentexecutionbox">
        <div className="text-center">
          
          <div className="payment-success">
            <i className="fa-regular fa-circle-xmark text-danger"></i>
          </div>

          <h4 className="text-danger mt-3">Deposit Failed</h4>
          <Link
            className="btn bg_btn mt-3"
            to={token ? `${base_url}userdashboarddeposit` : base_url}
                state={token ? { from: "deposit" } : ""}
          >
            Try Again
          </Link>

        </div>
      </div>
    </div>
  </div>
</div>
  )
}

export default Faied
